import maxBy from 'lodash/maxBy';
import minBy from 'lodash/minBy';
import get from 'lodash/get';
import moment from 'moment';

import HistoricalScenario from '@/types/historical-scenario';

const calculateStartAndEndDates = (scenarios: HistoricalScenario[]) => {
  const latestSelectedScenarioStartingDate = get(
    minBy(scenarios, item => moment(item.startDate).valueOf()),
    'startDate',
  );
  const latestSelectedScenarioEndingDate = get(
    maxBy(scenarios, item => moment(item.endDate).valueOf()),
    'endDate',
  );

  return {
    startDate: latestSelectedScenarioStartingDate ? new Date(latestSelectedScenarioStartingDate) : null,
    endDate: latestSelectedScenarioEndingDate ? new Date(latestSelectedScenarioEndingDate) : null,
  };
};

export default calculateStartAndEndDates;
